import React, { useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./Reports.css";
import { Line } from "react-chartjs-2";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";

// Register Chart.js modules
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// World Map Component
const WorldMap = () => {
  return (
    <MapContainer
      center={[20, 0]} // Centered at a point near the equator and prime meridian
      zoom={2} // Zoom level to display the entire world
      style={{ height: "400px", width: "100%" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
    </MapContainer>
  );
};

// Reports Component
const Reports = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
    console.log("Selected date:", date);
  };

  const lineData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Visitors",
        data: [1200, 1582, 1350, 1600, 1900, 2100, 2200, 2500, 2700, 3000, 3200, 4000],
        borderColor: "#4F46E5",
        tension: 0.4,
        fill: false,
      },
    ],
  };

  const lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          borderDash: [5, 5],
        },
      },
    },
  };

  return (
    <div className="reports-wrapper min-h-screen bg-gray-50 p-6">
      <div className="reports-container mx-auto space-y-6">
        {/* Header */}
        <header className="reports-header">
          <h1 className="reports-title">Report & Analytics</h1>
        </header>

        {/* Stats Cards */}
        <div className="reports-stats grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[{ title: "Total Users", value: "2,382", change: "-3.65%", color: "text-red-500", icon: "👥" },
            { title: "Pending Requests", value: "64", change: "-2.25%", color: "text-red-500", icon: "⏳" },
            { title: "Visitors", value: "14,212", change: "+5.25%", color: "text-green-500", icon: "🌐" }, 
            { title: "Earnings", value: "$21,300", change: "+6.85%", color: "text-green-500", icon: "💰" },
          ].map((item, index) => (
            <div key={index} className="reports-card p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition">
              <div className="reports-card-content flex justify-between items-center">
                <div>
                  <h3 className="reports-card-title text-sm font-medium text-gray-500">{item.title}</h3>
                  <p className="reports-card-value text-xl font-semibold text-gray-800">{item.value}</p>
                </div>
                <span className="reports-card-icon text-2xl">{item.icon}</span>
              </div>
              <p className={`reports-card-change text-sm ${item.color}`}>{item.change} Since last week</p>
            </div>
          ))}
        </div>

        {/* Charts and Browser Usage */}
        <div className="reports-main grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="reports-chart bg-white rounded-lg shadow-md p-4 lg:col-span-2">
            <h3 className="reports-chart-title text-lg font-medium text-gray-700 mb-4">Recent Movement</h3>
            <Line data={lineData} options={lineOptions} />
          </div>

          <div className="reports-browser bg-white rounded-lg shadow-md p-4">
            <h3 className="reports-browser-title text-lg font-medium text-gray-700 mb-4">Browser Usage</h3>
            <div className="reports-browser-content flex items-center space-x-4">
              <div className="reports-browser-chart w-24 h-24 rounded-full border-t-4 border-blue-500 border-r-4 border-yellow-500 animate-spin-slow"></div>
              <ul className="reports-browser-list space-y-2">
                {[{ label: "Chrome", percentage: "12%", count: 4306, color: "text-blue-500" },
                  { label: "Firefox", percentage: "-3%", count: 3801, color: "text-yellow-500" },
                  { label: "Edge", percentage: null, count: 1689, color: "text-gray-500" },
                  { label: "Other", percentage: null, count: 3251, color: "text-gray-400" },
                ].map((item, index) => (
                  <li key={index} className="reports-browser-item flex justify-between text-gray-700">
                    <span className={`reports-browser-label ${item.color}`}>{item.label}</span>
                    <span className="reports-browser-count">{item.count}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Calendar and World Map */}
        <div className="reports-secondary grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="reports-calendar">
            <h3 className="reports-calendar-title">Calendar</h3>
            <div className="reports-calendar-content">
              <Calendar
                onChange={handleDateChange}
                value={selectedDate}
                className="rounded-md shadow-sm"
              />
            </div>
            <p className="text-sm text-gray-600 mt-4">
              Selected Date: <span className="font-medium">{selectedDate.toDateString()}</span>
            </p>
          </div>

          <div className="reports-worldmap bg-white rounded-lg shadow-md p-4">
            <h3 className="reports-worldmap-title text-lg font-medium text-gray-700 mb-4">World Map</h3>
            <WorldMap />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
